import { Box } from "@mui/material";
import { ONBOARDING_COLORS } from "../../features/organisations/onboarding/onboardingDesign.js";
import { FittedCode } from "./FittedCode.js";

interface Props {
  /** The code, already formatted as XXX-XXX. */
  code: string;
}

/** The pairing code in large monospace digits on a light card (phone width). */
export const PairingCodeCard = ({ code }: Props) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      minWidth: 0,
      px: 2,
      py: 3,
      border: 1,
      borderColor: ONBOARDING_COLORS.border,
      borderRadius: "8px",
      bgcolor: ONBOARDING_COLORS.selectedBackground,
      containerType: "inline-size",
    }}
  >
    <FittedCode code={code} maxFontSize="3rem" />
  </Box>
);
